/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/jobs/:job_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { integrationsDirectCdiJobsJobId } from "./constants";
import type { CdiSyncJob } from "./types";

export const getCdiJobById = reactQueryFetcherAdapter(
  integrationsDirectCdiJobsJobId,
  (signal: AbortSignal, jobId: string): Promise<CdiSyncJob> => {
    return fetch(`/integrations/direct/cdi/jobs/${jobId}`, "GET", {}, { signal });
  }
);
